<template>
  <div class="your-plan">
    <Margins>
      <YourPlanTable :showPaymentAmount="showPaymentAmount" />
    </Margins>
  </div>
</template>

<script>
import { Margins } from '@/components';
import YourPlanTable from './YourPlanTable.vue';

export default {
  name: 'YourPlan',
  components: {
    Margins,
    YourPlanTable,
  },
  props: {
    showPaymentAmount: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss">
.your-plan {
  @include min-width(sm) {
    padding: 1rem;
  }
}
</style>
